import $ from 'jquery';
import '../forgot-credentials/vue.vue';

const refreshVisibility = () => {
  const forgotMode = $('[name="forgot_credentials[forgetType]"]:checked').val();

  if (forgotMode === 'password') {
    $('#forgot_credentials_username').closest('.form-group').show();
    $('#forgot_credentials_email').closest('.form-group').hide();
  } else {
    $('#forgot_credentials_username').closest('.form-group').hide();
    $('#forgot_credentials_email').closest('.form-group').show();
  }
};

refreshVisibility();
$('[name="forgot_credentials[forgetType]"]').on('click', refreshVisibility);



// WEBPACK FOOTER //
// ./src/VisualCraft/Bundle/VideoJetUserBundle/Resources/js/app/forget-credentials.js